import { Component } from '@angular/core';

@Component({
  selector: 'upsc-review-submitted-info',
  templateUrl: './review-submitted-info.component.html',
  styleUrls: ['./review-submitted-info.component.scss']
})
export class ReviewSubmittedInfoComponent {

}
